import { AxiosError } from 'axios';
import { useState } from 'react';

import { KycStatusInterface } from '../../../models/dashboard/dashboard/kyc-status';
import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import { kycStatusDataActions } from '../../../redux/slices/kycStatusSlice';
import { useAppDisPatch } from '../../../redux/store';
import useHttps from '../../useHttps';

const useKycStatus = () => {
    const request = useHttps();
    const dispatch = useAppDisPatch();
    const [loading, setLoading] = useState(false);

    const onKycStatusError = (err: AxiosError<ErrorHttpResponse>) => {
        console.error(err?.response?.data?.message ?? 'Something went wrong');
    };

    const onKycStatusSuccess = ({
        data,
        message,
    }: SuccessHttpResponse<KycStatusInterface>) => {
        dispatch(kycStatusDataActions.setKycStatusData(data));
    };

    const kycStatus = async () => {
        const url: HttpConfig = {
            url: `api/v1/company/kyc/status`,
            method: 'get',
        };

        return request(url, onKycStatusSuccess, setLoading, onKycStatusError);
    };

    return { kycStatus, loading };
};

export default useKycStatus;
